// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"16cfa228","427":"fe16f679","453":"8d4a9a19"}[chunkId] + ".chunk.js";
};